<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wOTzlX/tc-custom/9781429909914.jpg?1718106264141" alt="This image is the cover for the book Service and Style"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Service and Style
      </h1>
      <p class="bookDescription body article font2">
        <p>Downtown department stores were once the heart and soul of America's pulsing Broadways and Main Streets. With names such as City of Paris, Penn Traffic, The Maze, Maison Blanche, or The Popular, they suggested spheres far beyond mundane shopping. Nicknames reflected the affection customers felt for their favorites, whether Woodie's, Wanny's, Stek's, O.T.'s, Herp's, or Bam's.<br/><br/> The history of downtown department stores is as fascinating as their names and as diverse as their merchandise. Their stories encompass many themes: the rise of decorative design, new career paths for women, the growth of consumerism, and the technological ingenuity of escalators and pneumatic tubes. Just as the big stores made up their own small universes, their stories are microcosmic narratives of American culture and society.<br/><br/> The big stores were much more than mere businesses. They were local institutions where shoppers could listen to concerts, see fashion shows and art exhibits, learn golf or bridge, pay electric bills, and plan vacations – all while their children played in the store's nursery under the eye of a uniformed nursemaid.<br/><br/>From Boston to San Diego and Miami to Seattle, department stores symbolized a city's spirit, wealth, and progressiveness. Situated at busy intersections, they occupied the largest and finest downtown buildings, and their massive corner clocks became popular meeting places. Their locations became the epicenters of commerce, the high point from which downtown property taxes were calculated. Spanning the late 19th century well into the 20th, their peak development mirrors the growth of cities and of industrial America when both were robust and flourishing. <br/><br/> The time may be gone when children accompany their mothers downtown for a day of shopping and lunch in the tea room, when monogrammed trucks deliver purchases for free the very same day, and when the personality of a city or town can be read in its big stores. But they are far from forgotten and they still have power to influence how we shop today.<br/><br/><i> Service and Style</i> recreates the days of downtown department stores in their prime, from the 1890s through the 1960s. Exploring in detail the wide range of merchandise they sold, particularly style goods such as clothing and home furnishings, it examines how they displayed, promoted, and sometimes produced goods. It reveals how the stores grew, why they declined, and how they responded to and shaped the society around them.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jan Whitaker
      </h2>
      
      <p class="authorDescription body article"><P><B>Jan Whitaker</B> is a writer and freelance editor based in Amherst, Massachusetts.  She is the author of <I>Tea at the Blue Lantern Inn: A Social History of the Tea Room Craze in America</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ST. MARTIN’S PRESS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1bd96978